<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('affiliateRuleManage.queryCondition') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            v-model="affiliateRuleManageInfo.conditions.name"
            :placeholder="$t('affiliateRuleManage.ruleNamePlaceholder')"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="_queryAffiliateRuleMethod">
            {{ $t('affiliateRuleManage.query') }}
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('affiliateRuleManage.affiliateRule') }}</span>
        <el-button
          type="primary"
          size="small"
          style="float: right"
          @click="_openAddAffiliateRuleModal"
        >
          {{ $t('affiliateRuleManage.add') }}
        </el-button>
      </div>
      <el-table
        :data="affiliateRuleManageInfo.affiliateRules"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="ruleId"
          :label="$t('affiliateRuleManage.ruleId')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          :label="$t('affiliateRuleManage.ruleName')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="level1Rate"
          :label="$t('affiliateRuleManage.level1Rate')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="level2Rate"
          :label="$t('affiliateRuleManage.level2Rate')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="level21Rate"
          :label="$t('affiliateRuleManage.level21Rate')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="expireDay"
          :label="$t('affiliateRuleManage.expireDay')"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.expireDay }}{{ $t('affiliateRuleManage.day') }}
          </template>
        </el-table-column>
        <el-table-column
          prop="state"
          :label="$t('affiliateRuleManage.state')"
          align="center"
        >
          <template slot-scope="scope">
            {{ _state(scope.row.state) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('affiliateRuleManage.operation')"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="_openEditAffiliateRuleModel(scope.row)"
            >
              {{ $t('affiliateRuleManage.edit') }}
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="_openDeleteAffiliateRuleModel(scope.row)"
            >
              {{ $t('affiliateRuleManage.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="affiliateRuleManageInfo.total"
      ></el-pagination>
    </el-card>

    <add-affiliate-rule ref="addAffiliateRule"></add-affiliate-rule>
    <edit-affiliate-rule ref="editAffiliateRule"></edit-affiliate-rule>
    <delete-affiliate-rule ref="deleteAffiliateRule"></delete-affiliate-rule>
  </div>
</template>

<script>
import { listAffiliateRule } from '@/api/affiliate/affiliateRuleApi'
import AddAffiliateRule from '@/components/affiliate/addAffiliateRule'
import EditAffiliateRule from '@/components/affiliate/editAffiliateRule'
import DeleteAffiliateRule from '@/components/affiliate/deleteAffiliateRule'

export default {
  name: 'AffiliateRuleManage',
  components: {
    AddAffiliateRule,
    EditAffiliateRule,
    DeleteAffiliateRule
  },
  data() {
    return {
      affiliateRuleManageInfo: {
        affiliateRules: [],
        total: 0,
        conditions: {
          name: '',
          page: 1,
          row: 10
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listAffiliateRules()
  },
  methods: {
    async _listAffiliateRules() {
      try {
        const res = await listAffiliateRule(this.affiliateRuleManageInfo.conditions)
        this.affiliateRuleManageInfo.affiliateRules = res.data
        this.affiliateRuleManageInfo.total = res.total
      } catch (error) {
        console.error(error)
      }
    },
    _openAddAffiliateRuleModal() {
      this.$refs.addAffiliateRule.open()
    },
    _openEditAffiliateRuleModel(row) {
      this.$refs.editAffiliateRule.open(row)
    },
    _openDeleteAffiliateRuleModel(row) {
      this.$refs.deleteAffiliateRule.open(row)
    },
    _queryAffiliateRuleMethod() {
      this.currentPage = 1
      this.affiliateRuleManageInfo.conditions.page = 1
      this._listAffiliateRules()
    },
    _state(state) {
      return state === '0'
        ? this.$t('affiliateRuleManage.disabled')
        : this.$t('affiliateRuleManage.enabled')
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.affiliateRuleManageInfo.conditions.page = val
      this._listAffiliateRules()
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>